{
  "blocks": [
    {
      "id": "program-ivf-cycle",
      "kind": "program",
      "tags": ["ivf", "both-partners", "treatment", "during-cycle"],
      "title": "IVF Cycle",
      "subtitle": "End-to-end IVF, from assessment through transfer",
      "icon": "🧬",
      "body": {
        "duration": "4 weeks – 6 months",
        "includes": [
          "Full fertility assessment for both partners",
          "Optional 90-day optimization for her and him",
          "Ovarian stimulation with daily monitoring",
          "Egg retrieval and sperm collection",
          "Fertilization and embryo culture to blastocyst",
          "Optional PGT-A genetic screening",
          "Embryo transfer with luteal phase support",
          "Two-week wait support and beta-hCG testing"
        ],
        "priceRange": {
          "low": 18000,
          "high": 30000
        },
        "currency": "USD",
        "status": "coming-soon",
        "forWhom": "both",
        "category": "treatment",
        "customizable": true,
        "moduleIds": [
          "module-female-hormone-baseline",
          "module-male-fertility-baseline",
          "module-female-optimization",
          "module-male-optimization",
          "module-ovarian-stimulation",
          "module-egg-retrieval",
          "module-fertilization-culture",
          "module-pgt-a",
          "module-embryo-transfer",
          "module-tww-support"
        ],
        "optionalModuleIds": [
          "module-female-optimization",
          "module-male-optimization",
          "module-pgt-a"
        ],
        "phases": [
          {
            "title": "Assessment",
            "description": "Full workup for both partners",
            "moduleIds": [
              "module-female-hormone-baseline",
              "module-male-fertility-baseline"
            ],
            "parallel": true
          },
          {
            "title": "Optimize (optional)",
            "description": "90 days of preparation for both",
            "moduleIds": [
              "module-female-optimization",
              "module-male-optimization"
            ],
            "parallel": true
          },
          {
            "title": "Stimulation & Retrieval",
            "description": "Stimulation, retrieval, fertilization",
            "moduleIds": [
              "module-ovarian-stimulation",
              "module-egg-retrieval",
              "module-fertilization-culture"
            ]
          },
          {
            "title": "Screening (optional)",
            "description": "PGT-A genetic testing of embryos",
            "moduleIds": ["module-pgt-a"]
          },
          {
            "title": "Transfer & TWW",
            "description": "Embryo transfer and two-week wait",
            "moduleIds": ["module-embryo-transfer", "module-tww-support"]
          }
        ],
        "steps": [
          {
            "title": "Assessment",
            "description": "Full fertility workup for both partners."
          },
          {
            "title": "Optimize (optional)",
            "description": "90 days of supplements and lifestyle changes."
          },
          {
            "title": "Stimulation & Retrieval",
            "description": "10–14 days of stimulation, retrieval, fertilization, and embryo culture."
          },
          {
            "title": "Transfer",
            "description": "Single embryo transfer with progesterone support and TWW guidance."
          }
        ]
      },
      "sources": [
        {
          "title": "ART national summary report",
          "journal": "CDC / SART",
          "year": 2022,
          "evidenceLevel": "cohort"
        }
      ]
    }
  ],
  "relationships": [
    {
      "from": "program-ivf-cycle",
      "to": "module-female-hormone-baseline",
      "type": "contains"
    },
    {
      "from": "program-ivf-cycle",
      "to": "module-male-fertility-baseline",
      "type": "contains"
    },
    {
      "from": "program-ivf-cycle",
      "to": "module-female-optimization",
      "type": "contains"
    },
    {
      "from": "program-ivf-cycle",
      "to": "module-male-optimization",
      "type": "contains"
    },
    {
      "from": "program-ivf-cycle",
      "to": "module-ovarian-stimulation",
      "type": "contains"
    },
    {
      "from": "program-ivf-cycle",
      "to": "module-egg-retrieval",
      "type": "contains"
    },
    {
      "from": "program-ivf-cycle",
      "to": "module-fertilization-culture",
      "type": "contains"
    },
    {
      "from": "program-ivf-cycle",
      "to": "module-pgt-a",
      "type": "contains"
    },
    {
      "from": "program-ivf-cycle",
      "to": "module-embryo-transfer",
      "type": "contains"
    },
    {
      "from": "program-ivf-cycle",
      "to": "module-tww-support",
      "type": "contains"
    }
  ],
  "localeVariants": []
}
